import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { formatTime, minutesSince } from "@/lib/format";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ChefHat, Check, Clock } from "lucide-react";

export default function KDS() {
  const { t, lang } = useI18n();
  const [orders, setOrders] = useState([]);

  const load = async () => {
    const { data } = await api.get("/kds/orders");
    setOrders(data);
  };
  useEffect(() => {
    load();
    const iv = setInterval(load, 8000);
    return () => clearInterval(iv);
  }, []);

  const updateStatus = async (order_id, item_id, status) => {
    await api.put(`/orders/${order_id}/items/${item_id}`, { status });
    await load();
  };

  return (
    <div className="p-4 md:p-8 space-y-6">
      <div className="flex justify-between items-end">
        <div>
          <h1 className="font-display font-bold text-3xl tracking-tight flex items-center gap-2">
            <ChefHat className="w-7 h-7 text-primary" /> {t("kds")}
          </h1>
          <p className="text-sm text-muted-foreground mt-1">{orders.length} · {lang === "tr" ? "aktif" : "aktiv"}</p>
        </div>
      </div>

      {orders.length === 0 && (
        <div className="text-center py-16 border border-dashed rounded-lg text-muted-foreground">
          {lang === "tr" ? "Aktif sipariş yok" : "Keine aktiven Bestellungen"}
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3">
        {orders.map((o) => {
          const mins = minutesSince(o.created_at);
          const stale = mins > 15;
          return (
            <Card
              key={o.id}
              className={`border shadow-none ${stale ? "border-destructive" : ""}`}
              data-testid={`kds-ticket-${o.id}`}
            >
              <CardContent className="p-3">
                <div className="flex justify-between items-center pb-2 border-b">
                  <div className="font-mono text-sm font-semibold">#{o.id.slice(0, 6)}</div>
                  <div className={`text-xs font-mono flex items-center gap-1 ${stale ? "text-destructive" : "text-muted-foreground"}`}>
                    <Clock className="w-3 h-3" /> {mins}′ · {formatTime(o.created_at)}
                  </div>
                </div>
                <div className="mt-2 space-y-2">
                  {o.items.map((it) => (
                    <div key={it.id} className="flex justify-between items-start gap-2">
                      <div className="flex-1 min-w-0">
                        <div className="text-sm font-medium">
                          <span className="font-mono">{it.qty}×</span> {it.name_snapshot}
                        </div>
                        {it.note && <div className="text-xs text-muted-foreground italic mt-0.5">{it.note}</div>}
                      </div>
                      <Button
                        size="sm"
                        variant={it.status === "ready" ? "secondary" : "outline"}
                        onClick={() =>
                          updateStatus(o.id, it.id, it.status === "ready" ? "new" : "ready")
                        }
                        data-testid={`kds-toggle-${it.id}`}
                        className="h-7 px-2"
                      >
                        <Check className="w-3 h-3 mr-1" /> {it.status === "ready" ? "OK" : (lang === "tr" ? "Hazır" : "Fertig")}
                      </Button>
                    </div>
                  ))}
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
